
import { useEffect, useState, useRef } from 'react';

interface MetricItem {
  value: number;
  suffix: string;
  label: string;
  icon: string;
}

const metrics: MetricItem[] = [
  { value: 500, suffix: '+', label: 'Empresas Transformadas', icon: 'ri-building-2-line' },
  { value: 127, suffix: '%', label: 'Crescimento Médio', icon: 'ri-line-chart-line' },
  { value: 2, suffix: 'M+', label: 'Atendimentos Realizados', icon: 'ri-message-3-line' },
  { value: 98, suffix: '%', label: 'Taxa de Satisfação', icon: 'ri-heart-line' },
];

function AnimatedNumber({ value, suffix }: { value: number; suffix: string }) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          let start = 0;
          const duration = 2000;
          const increment = value / (duration / 16);
          
          const timer = setInterval(() => {
            start += increment;
            if (start >= value) {
              setCount(value);
              clearInterval(timer);
            } else {
              setCount(Math.floor(start));
            }
          }, 16);
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [value, hasAnimated]);

  return (
    <div ref={ref} className="text-6xl md:text-7xl font-bold text-white">
      {count}{suffix}
    </div>
  );
}

export default function GlobalMetrics() {
  return (
    <section className="py-20 bg-gradient-to-r from-[#10B981] to-[#059669] relative overflow-hidden">
      {/* Padrão de fundo */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, black 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
            Números que Falam por Si
          </h2>
          <p className="text-black/70 text-lg">
            Resultados reais de empresas reais usando NeuroAgents
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {metrics.map((metric, index) => (
            <div 
              key={index}
              className="text-center p-8 bg-black/10 backdrop-blur-sm rounded-2xl"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-black/20 rounded-2xl mx-auto mb-6">
                <i className={`${metric.icon} text-white text-3xl`}></i>
              </div>
              <AnimatedNumber value={metric.value} suffix={metric.suffix} />
              <p className="text-black/80 text-sm mt-2 font-medium">{metric.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
